<ng-container *ngIf="snoozeEnd">
  <p *ngIf="productsService.isDateWithinCurrentYear(snoozeEnd)">
    {{ 'AVAILABLE_IN' | translate:{date: getDateTillSnoozeEnd()} }}
  </p>

  <p *ngIf="!productsService.isDateWithinCurrentYear(snoozeEnd)">
    {{ 'NOT_AVAILABLE_ATM' | translate }}
  </p>
</ng-container>
